import { PropsWithChildren, Suspense } from 'react';
import * as ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { ToastProvider } from 'react-toast-notifications';

import FullPageLoadingContainer from './packages/kakapo-ui-application/pages/loading/FullPageLoadingContainer';
import ConfigGuard from 'packages/kakapo-ui-application/containers/ConfigGuard';

/* Plugin provider imports */
import {
	WorkspaceProvider,
	MantineProvider,
	ApolloProvider,
	WorkspaceThemeProvider,
	BaseThemeProvider,
	withContextProviders,
} from 'plugins';

/* Plugin initalizations */
import { initializePlugins } from './plugins';
initializePlugins();

/* Component definition */
const SuspenseProvider = ({ children }: PropsWithChildren) => {
	return <Suspense fallback={<FullPageLoadingContainer />}>{children}</Suspense>;
};

/**
 * Order determines wrapping order
 * @example
 * const providers = [provA,provB,provC]
 * withContextProviders(providers)(Root)
 *
 * gives output
 *	<provA>
 *		<provB>
 *			<provC>
 *				etc...
 *			<provC>
 *		<provB>
 *	<provA>
 */
const providers: React.ComponentType[] = [
	BaseThemeProvider,
	SuspenseProvider,
	BrowserRouter,
	WorkspaceProvider,
	ApolloProvider,
	ToastProvider,
	WorkspaceThemeProvider,
	MantineProvider,
];

/**
 * Base things that need to be wrapped
 * @returns Base component
 */
const Base = () => {
	return <ConfigGuard />;
};

export const Root = withContextProviders(providers)(Base);

// eslint-disable-next-line react/no-deprecated
ReactDOM.render(<Root />, document.getElementById('root')!);
